<template>
  <div>
    <HrPageLayout
      title="Polls"
      subtitle="Participate in company polls"
      icon="📊"
      :breadcrumb-items="[
        { label: 'Dashboard', route: '/employee-dashboard' },
        { label: 'Polls' }
      ]"
    >
      <div class="my-polls-content">
        <div v-if="!loading && polls.length > 0" class="hr-metrics-grid hr-mb-4">
          <div class="hr-metric-card gradient-1">
            <div class="hr-metric-icon"><i class="bx bx-pie-chart-alt"></i></div>
            <div class="hr-metric-content">
              <p class="hr-metric-label">Active polls</p>
            <h2 class="hr-metric-value">{{ polls.length }}</h2>
            </div>
          </div>
          <div class="hr-metric-card gradient-3">
            <div class="hr-metric-icon"><i class="bx bx-check-double"></i></div>
            <div class="hr-metric-content">
              <p class="hr-metric-label">Voted</p>
            <h2 class="hr-metric-value">{{ votedCount }}</h2>
            </div>
          </div>
        </div>
        <div v-if="loading" class="hr-loading-wrap hr-py-5">
          <div class="hr-spinner"></div>
          <p class="hr-text-muted hr-mt-2">Loading polls...</p>
        </div>

        <div v-else-if="!polls.length" class="hr-chart-card hr-text-center hr-py-5">
          <i class="bx bx-pie-chart-alt" style="font-size: 48px; color: #5b73e8;"></i>
          <h5 class="hr-mt-4">No Active Polls</h5>
          <p class="hr-text-muted">There are no polls for you to participate in at the moment.</p>
        </div>

        <div v-else class="polls-grid">
          <div v-for="p in polls" :key="p.id" class="poll-card">
            <div class="poll-card-body">
              <h5 class="poll-card-title">{{ p.title }}</h5>
              <p v-if="p.description" class="hr-text-muted hr-small hr-mb-2">{{ p.description }}</p>
              <p class="hr-text-muted hr-small hr-mb-3">
                <i class="bx bx-calendar"></i> Ends: {{ formatDate(p.end_date) }}
              </p>
              <router-link v-if="!votedMap[p.id]" :to="{ name: 'poll-vote', params: { id: p.id } }" class="hr-btn hr-btn-primary hr-btn-sm hr-btn-block">
                <i class="bx bx-check-square"></i> Vote
              </router-link>
              <router-link v-else :to="{ name: 'poll-vote', params: { id: p.id } }" class="hr-btn hr-btn-outline hr-btn-sm hr-btn-block">
                <i class="bx bx-bar-chart-alt"></i> View results
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </HrPageLayout>
  </div>
</template>

<script>
/* eslint-disable */
import HrPageLayout from "@/components/hrActions/HrPageLayout.vue";
import { authUrl, execute } from "@/api";

export default {
  name: "MyPolls",
  components: { HrPageLayout },
  data() {
    return {
      loading: false,
      polls: [],
      votedMap: {}
    };
  },
  computed: {
    votedCount() {
      return Object.keys(this.votedMap).filter((id) => this.votedMap[id]).length;
    }
  },
  mounted() {
    this.loadPolls();
  },
  methods: {
    getSessionIdNo() {
      const direct = sessionStorage.getItem("idNo");
      if (direct) return direct;
      try {
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
        return userInfo.idNo || "";
      } catch (e) {
        return "";
      }
    },
    formatDate(val) {
      if (!val) return "-";
      const d = new Date(val);
      return isNaN(d.getTime()) ? val : d.toLocaleDateString();
    },
    loadPolls() {
      this.loading = true;
      const data = new FormData();
      data.append("function", "getEligiblePollsForStaff");
      data.append("sessionIdNo", this.getSessionIdNo());
      const roleNames = sessionStorage.getItem("selectedRoles");
      if (roleNames) {
        try {
          const roles = JSON.parse(roleNames);
          const names = Array.isArray(roles) ? roles.map((r) => r.role_name || r.roleName).filter(Boolean) : [];
          if (names.length) data.append("roleNames", JSON.stringify(names));
        } catch (e) {}
      }
      execute(data, authUrl)
        .then((res) => {
          this.loading = false;
          if (res.data.success && Array.isArray(res.data.data)) {
            this.polls = res.data.data;
            this.checkVoted();
          } else {
            this.polls = [];
          }
        })
        .catch(() => {
          this.loading = false;
          this.polls = [];
        });
    },
    checkVoted() {
      this.polls.forEach((p) => {
        const data = new FormData();
        data.append("function", "hasUserVoted");
        data.append("pollId", p.id);
        data.append("sessionIdNo", this.getSessionIdNo());
        execute(data, authUrl)
          .then((r) => {
            if (r.data.success && r.data.data && r.data.data.voted) {
              this.$set(this.votedMap, p.id, true);
            }
          })
          .catch(() => {});
      });
    }
  }
};
</script>

<style scoped>
@import "@/assets/css/hr-page-shared.css";
.polls-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 20px; }
.poll-card { border: 1px solid #e2e8f0; border-radius: 16px; overflow: hidden; transition: all 0.3s; }
.poll-card:hover { transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,0.08); }
.poll-card-body { padding: 24px; }
.poll-card-title { margin-bottom: 12px; font-size: 16px; }
.hr-btn-block { width: 100%; justify-content: center; }
.hr-btn-outline { background: transparent; border: 1px solid #e2e8f0; color: #475569; }
.hr-btn-outline:hover { background: #f8fafc; border-color: #5b73e8; color: #5b73e8; }
</style>
